import styled from "@emotion/styled";
import { KonturColors } from "@skbkontur/colors";

import { theme } from "../../../Internals/ThemeProvider/CandyTheme/ThemeShorthand";

export const PaymentBannerRoot = styled.div(props => ({
    backgroundColor: KonturColors.yellow20,
    borderRadius: "16px",
    fontSize: "16px",
    lineHeight: "22px",
    padding: theme(props).size(2),
    textAlign: "center",
}));

export const PaymentBannerCaption = styled.div(props => ({
    marginBottom: theme(props).size(1),
}));
